import React from "react"
import AdSense from "react-adsense"

interface Props {
  styles: any
}
const GoogleAdSense = (props: Props) => {
  const { styles } = props
  const GOOGLE_AD_ID = "ca-pub-4985175725322771"

  return (
    <>
      <AdSense.Google
        client={GOOGLE_AD_ID}
        slot="5471283174"
        style={styles}
        format="fluid"
        responsive="true"
        layoutKey="-gw-1+2a-9x+5c"
      />
    </>
  )
}

export default GoogleAdSense
